export const contactTypes = {
  MESSAGE: 'contactcentre',
  CALL: 'talkToScope',
};

export const contactTargets = {
  PERSONAL_ADVISER: 'PERSONAL_ADVISER',
  ANALYST: 'ANALYST',
  SERVICE_CENTRE: 'SERVICE_CENTRE',
};